<template>
  <div class="testimonial-area pt-100">
    <div class="container mw-1356">
      <div class="testimonial-wrap bg-img pb-100" :style="{ backgroundImage: `url(${bgImage})` }">
        <div class="section-title text-center mw-860 m-auto mb-90">
          <span class="top-title">{{ c.top_title }}</span>
          <h2 class="text-white">{{ c.title }}</h2>
          <p class="text-white">{{ c.description }}</p>
        </div>

        <div class="position-relative z-1">
          <Swiper :slidesPerView="1" :spaceBetween="50" :loop="true"
            :autoplay="{ delay: 2000, disableOnInteraction: false }"
            :navigation="{ nextEl: '.next', prevEl: '.prev' }"
            :breakpoints="{ 992: { slidesPerView: 2 }, 1440: { slidesPerView: 2 } }"
            :modules="modules" class="testomonial-slide-two">
            <SwiperSlide v-for="(t, index) in c.items" :key="index">
              <div class="testimonial-single-item-two">
                <div class="d-flex align-items-center mb-32">
                  <div class="flex-shrink-0">
                    <img :src="t.image_url || fallbackAvatar" :alt="t.name" />
                  </div>
                  <div class="flex-grow-1 ms-4">
                    <ul class="ps-0 list-unstyled d-flex align-items-center gap-1">
                      <li v-for="star in 5" :key="star">
                        <i :class="star <= (t.rating || 5) ? 'ti ti-star-filled' : 'ti ti-star'"></i>
                      </li>
                    </ul>
                    <h3>{{ t.name }}</h3>
                  </div>
                </div>
                <p>{{ t.review }}</p>
              </div>
            </SwiperSlide>
          </Swiper>
          <div class="testomonial-controller">
            <div class="controller-icon prev"><i class="ti ti-arrow-left"></i></div>
            <div class="controller-icon next"><i class="ti ti-arrow-right"></i></div>
          </div>

          <div v-if="c.reviews_url" class="text-center mt-5">
            <a :href="c.reviews_url" target="_blank" rel="noopener" class="btn">
              <span class="border-style">{{ c.reviews_label || 'Read all our reviews' }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Navigation } from "swiper/modules";
import { useContent } from "@/composables/useContent";

export default defineComponent({
  name: "OurTestimonial",
  components: { Swiper, SwiperSlide },
  setup() {
    const { content: c } = useContent("testimonials", {
      top_title: "TESTIMONIAL", title: "Being nice shouldn't be an afterthought",
      description: "The reviews are in and we're as obsessed with your internet as you are.",
      reviews_url: "",
      reviews_label: "Read all our reviews",
      items: [
        { name: "Britteney Anderson", review: "Even though I ended up staying, I want to commend Sara for her professionalism, knowledge, patience, and excellent service.", image_url: "", rating: 5 },
        { name: "Victor James", review: "Don't give up, you guys are doing a lot of good in an industry that needs the competition!", image_url: "", rating: 5 },
      ],
    });
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const bgImage = require("@/assets/images/testimonial-bg.png");
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const fallbackAvatar = require("@/assets/images/testimonial-1.jpg");
    return { c, bgImage, fallbackAvatar, modules: [Autoplay, Navigation] };
  },
});
</script>
